import { render, staticRenderFns } from "./the-royal-dutch-cricket-association-partners-with-ludimos.vue?vue&type=template&id=68a4072c&scoped=true&"
var script = {}
import style0 from "./the-royal-dutch-cricket-association-partners-with-ludimos.vue?vue&type=style&index=0&id=68a4072c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a4072c",
  null
  
)

export default component.exports